// extracted by mini-css-extract-plugin
module.exports = {"compact_container":"styles_compact_container__2toII","container":"styles_container__2XTgv"};